import clsx from "clsx";
import { formatMoney } from "@/lib/format";

interface MoneyProps {
  value: string | null | undefined;
  currency: string;
  /** Show a leading + for positive values. */
  signed?: boolean;
  /** Colour by sign (money in / out). Text tokens only — never a series colour. */
  tone?: boolean;
  className?: string;
}

/** Server-computed amount, formatted for display with tabular figures. */
export function Money({ value, currency, signed, tone, className }: MoneyProps) {
  const n = Number(value ?? 0);
  return (
    <span
      className={clsx(
        "num whitespace-nowrap",
        tone && n > 0 && "text-good",
        tone && n < 0 && "text-ink",
        className,
      )}
    >
      {formatMoney(value, currency, { signed })}
    </span>
  );
}
